export enum PaymentStatus {
  New = 'NEW',
  Pending = 'PENDING',
  Confirmed = 'CONFIRMED',
  Rejected = 'REJECTED',
  Expired = 'EXPIRED',
  Error = 'ERROR',
  // Used internally
  NotFound = 'NOT FOUND',
}
